/* eslint-disable  @typescript-eslint/no-explicit-any */
import { PersistConfig, createMigrate } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { RootState } from './rootReducer'
import SetTransform from './setTransform'

const migrations = {
  0: (state: any) => {
    return {
      ...state,
    }
  },
}

export const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  version: 0,
  storage,
  migrate: createMigrate(migrations),
  transforms: [SetTransform],
  blacklist: [
    'sales',
    'orders',
    'stores',
    'remoteConfig',
    'declarations',
    'stocks',
    'cart',
    'costPrice',
    'nutrition',
    'products',
    'quotes',
  ],
}
